import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.some.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "side-nav"
};
const _hoisted_2 = {
  class: "side-nav-link-label"
};
const _hoisted_3 = {
  key: 0,
  class: "side-nav-badge"
};
const _hoisted_4 = {
  key: 1,
  class: "side-nav-badge"
};
const _hoisted_5 = {
  class: "side-nav-user"
};
const _hoisted_6 = {
  class: "side-nav-user-row"
};
const _hoisted_7 = ["title"];
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { clearAuth, getAuthToken, getAuthUser } from '../auth';
import { chatUnread, chatEnabled, startChatClient, stopChatClient } from '../utils/chatClient';
export default {
  __name: 'SideNav',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const user = ref(getAuthUser());
    const flowPendingCount = ref(0);
    const displayName = computed(() => user.value?.name || user.value?.cell || '未登录');
    const role = computed(() => String(user.value?.role || localStorage.getItem('role') || '').trim().toLowerCase());
    const roleStore = computed(() => String(user.value?.store || localStorage.getItem('store') || '').trim());
    const isAdminRole = computed(() => ['admin', 'highadmin', 'superadmin'].includes(role.value));
    const canUsePos = computed(() => ['store', 'admin', 'highadmin', 'superadmin'].includes(role.value));
    const canUseFollowup = computed(() => ['store', 'manager', 'admin', 'highadmin', 'superadmin'].includes(role.value));
    const canUseInvoices = computed(() => ['manager', 'admin', 'highadmin', 'superadmin'].includes(role.value));
    const canUseWarehouse = computed(() => ['warehouse', 'superadmin'].includes(role.value));
    const canUseSalary = computed(() => ['manager', 'admin', 'highadmin', 'superadmin'].includes(role.value));
    const allNavItems = [{
      to: '/chat',
      label: '沟通'
    }, {
      to: '/reports',
      label: '报表'
    }, {
      to: '/analysis',
      label: '分析',
      adminOnly: true
    }, {
      to: '/followup',
      label: '跟进',
      followupOnly: true
    }, {
      to: '/goods',
      label: '商品',
      adminOnly: true
    }, {
      to: '/flows',
      label: '货流'
    }, {
      to: '/ordering',
      label: '订货',
      adminOnly: true
    }, {
      to: '/web-pos',
      label: '收银',
      posOnly: true
    }, {
      to: '/invoices',
      label: '开票',
      invoiceOnly: true
    }, {
      to: '/stocktake',
      label: '盘点',
      adminOnly: true
    }, {
      to: '/receipt-settings',
      label: '打印',
      hideForManager: true
    }, {
      to: '/downloads',
      label: '下载'
    }, {
      to: '/members',
      label: '会员'
    }, {
      to: '/team',
      label: '团队'
    }, {
      to: '/operations',
      label: '运营'
    }, {
      to: '/warehouse',
      label: '仓库',
      warehouseOnly: true
    }, {
      to: '/promotions',
      label: '促销',
      adminOnly: true
    }, {
      to: '/salary',
      label: '工资',
      salaryOnly: true
    }, {
      to: '/permissions',
      label: '权限',
      superadminOnly: true
    }, {
      to: '/settings',
      label: '设置',
      superadminOnly: true
    }];
    const navItems = computed(() => {
      const available = allNavItems.filter(item => item.to !== '/chat' || chatEnabled.value);
      if (role.value === 'chat_only') return available.filter(item => item.to === '/chat');
      if (role.value === 'picker') {
        return available.filter(item => item.to === '/operations' || item.to === '/chat');
      }
      return available.filter(item => {
        if (item.superadminOnly) return role.value === 'superadmin';
        if (item.posOnly) return canUsePos.value;
        if (item.followupOnly) return canUseFollowup.value;
        if (item.invoiceOnly) return canUseInvoices.value;
        if (item.warehouseOnly) return canUseWarehouse.value;
        if (item.salaryOnly) return canUseSalary.value;
        if (item.hideForManager && role.value === 'manager') return false;
        return !item.adminOnly || isAdminRole.value;
      });
    });
    const canSeeFlows = computed(() => navItems.value.some(item => item.to === '/flows'));
    const flowPendingBadge = computed(() => flowPendingCount.value > 99 ? '99+' : String(flowPendingCount.value));
    let flowPendingTimer = null;
    const encHeader = value => encodeURIComponent(String(value ?? '').trim());
    const authHeaders = () => {
      const headers = {};
      if (role.value) headers['x-role'] = role.value;
      if (roleStore.value) headers['x-store'] = encHeader(roleStore.value);
      return headers;
    };
    const loadFlowPendingCount = async () => {
      if (!canSeeFlows.value || !role.value) {
        flowPendingCount.value = 0;
        return;
      }
      try {
        const response = await fetch('/api/flows/pending-confirm-count', {
          headers: authHeaders(),
          cache: 'no-store'
        });
        if (!response.ok) return;
        const data = await response.json();
        flowPendingCount.value = Math.max(0, Number(data?.count || 0));
      } catch (_) {
        // 徽标刷新失败不影响页面主流程。
      }
    };
    const refreshUser = () => {
      user.value = getAuthUser();
      loadFlowPendingCount();
      startChatClient();
      if (user.value?.role === 'chat_only' && route.path !== '/chat') router.replace('/chat');
    };
    const openChat = () => router.push('/chat');
    const handleLogout = async () => {
      const token = getAuthToken();
      try {
        if (token) {
          await fetch('/api/auth/logout', {
            method: 'POST'
          });
        }
      } catch (_) {
        // 忽略退出接口异常，本地状态仍需清理
      } finally {
        clearAuth();
        router.replace('/login');
      }
    };
    onMounted(() => {
      startChatClient();
      window.addEventListener('chat-open', openChat);
      window.addEventListener('auth-changed', refreshUser);
      window.addEventListener('focus', loadFlowPendingCount);
      window.addEventListener('flow-pending-count-refresh', loadFlowPendingCount);
      loadFlowPendingCount();
      flowPendingTimer = window.setInterval(loadFlowPendingCount, 60 * 1000);
    });
    onUnmounted(() => {
      stopChatClient();
      window.removeEventListener('chat-open', openChat);
      window.removeEventListener('auth-changed', refreshUser);
      window.removeEventListener('focus', loadFlowPendingCount);
      window.removeEventListener('flow-pending-count-refresh', loadFlowPendingCount);
      if (flowPendingTimer) window.clearInterval(flowPendingTimer);
    });
    watch(() => route.fullPath, () => {
      loadFlowPendingCount();
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.to
        }, [_createVNode(_component_router_link, {
          to: item.to,
          class: "side-nav-link"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1), item.to === '/chat' && _unref(chatUnread) > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(chatUnread) > 99 ? '99+' : _unref(chatUnread)), 1)) : _createCommentVNode("", true), item.to === '/flows' && flowPendingCount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(flowPendingBadge.value), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["to"])]);
      }), 128))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "side-nav-user-name",
        title: displayName.value
      }, _toDisplayString(displayName.value), 9, _hoisted_7), _createElementVNode("button", {
        class: "side-nav-logout",
        type: "button",
        onClick: handleLogout
      }, "退出")])])]);
    };
  }
};